<template>
  <div class="row" id="table-hover-animation">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Savollar</h4>

          <button @click="testsQuestion"
                  class="btn btn-primary waves-effect waves-light">
            Savol qo'shish
          </button>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-hover mb-0">
                <thead>
                <tr>
                  <th scope="col">#</th>
                  <th>
                    Savol
                  </th>
                  <th>Qiyinlik darajasi</th>
                  <th>Savol turi</th>
                </tr>
                </thead>
                <tbody class="table-bordered">
                <tr v-for="(question, index) in questions">
                  <td scope="row">{{ index + 1 }}</td>
                  <td v-html="question.question">
                  </td>
                  <td>
                    {{ question.questionLevelName }}
                  </td>
                  <td>
                    {{ question.questionTypeName }}
                  </td>
                  <td class="d-flex justify-content-center">
                    <button @click="getQuestion(question.id, question.questionTypeId)"
                            class="btn btn-icon rounded-circle btn-flat-primary"
                            title="Ko'rish"
                            type="button">
                      <i class="feather icon-eye" style="font-size: 1.5rem"/>
                    </button>
                    <button @click="editQuestion(question.id, question.questionTypeId)"
                            class="btn btn-icon rounded-circle btn-flat-info"
                            title="Tahrirlash">
                      <i class="feather icon-edit" style="font-size: 1.5rem"/>
                    </button>
                    <button @click="deleteQuestion(question.id)"
                            class="btn btn-icon rounded-circle btn-flat-danger"
                            title="O'chirish"
                            type="button">
                      <i class="feather icon-trash-2" style="font-size: 1.5rem"/>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal :modal="modal" :modal-size="modalSize" @modal-closed="modal=false">
      <component :answers="answers"
                 :is="currentModal"
                 :question="question"
                 v-if="modal && deleteApi === ''">
      </component>
      <deleting-modal :delete-api="deleteApi"
                      @deleted="getQuestions"
                      v-if="deleteApi !== ''"/>
    </Modal>
  </div>
</template>

<script>
import SingleSelectionModal from "./QuestionTypes/Components/Modals/SingleSelectionModal";
import MultipleSelectionModal from "./QuestionTypes/Components/Modals/MultipleSelectionModal";
import SetupSequencesModal from "./QuestionTypes/Components/Modals/SetupSequencesModal";
import SetupMatchesModal from "./QuestionTypes/Components/Modals/SetupMatchesModal";
import FillingFieldModal from "./QuestionTypes/Components/Modals/FillingFieldModal";
import Modal from "../../components/Modal";
import DeletingModal from "../../components/DeletingModal";

export default {
  name: "TestsList",
  data() {
    return {
      questions: [],
      question: {},
      answers: [],
      currentModal: '',
      modal: false,
      deleteApi: '',
      modalSize: ''
    }
  },
  components: {
    DeletingModal,
    Modal,
    SingleSelectionModal,
    MultipleSelectionModal,
    SetupSequencesModal,
    SetupMatchesModal,
    FillingFieldModal
  },
  methods: {

    getQuestions() {
      let id = this.$route.params.id;
      if (id) {
        this.$store.commit('commitTestContentId', id);
        this.$api.get(`admin/Question/GetList/?contentId=${id}`)
            .then(res => {
              if (!res.error) {
                this.questions = res.result;
              }
            });

      }
    },
    testsQuestion() {
      localStorage.setItem('testContentId', this.$route.params.id);
      this.$store.commit('commitEditingTestId', null);
      this.$store.commit('commitEditingTestType', null);
      this.$router.push({name: 'tests-question'})
    },
    editQuestion(questionId, typeId) {
      this.$router.push('/tests-question/' + questionId + '/' + typeId);
    },
    deleteQuestion(questionId) {
      this.modalSize = 'modal-sm';
      this.deleteApi = `admin/Question/DeleteQuestion/${questionId}`;
      this.modal = true;
    },
    getQuestion(id, questionTypeId) {
      this.deleteApi = '';
      this.$api.get(`admin/Question/Get/${id}`)
          .then(res => {
            if (!res.error) {
              let resQuestion = res.result;
              switch (questionTypeId) {
                case 1:
                case 2:
                case 3:
                  this.question = {
                    ...this.question,
                    question: resQuestion.question,
                    ball: resQuestion.ball
                  };
                  this.question.ball = resQuestion.ball;
                  break;
                case 4:
                  this.question.question = resQuestion.question;
                  this.question.headerAnswer = resQuestion.headerAnswer;
                  this.question.headerAnswerCompatible = resQuestion.headerAnswerCompatible;
                  break;
                case 5:
                  this.question.question = resQuestion.question;
              }

              this.answers = resQuestion.answers;

              switch (questionTypeId) {
                case 1:
                  this.currentModal = 'SingleSelectionModal';
                  break;
                case 2:
                  this.currentModal = 'MultipleSelectionModal';
                  break;
                case 3:
                  this.currentModal = 'SetupSequencesModal';
                  break;
                case 4:
                  this.currentModal = 'SetupMatchesModal';
                  break;
                case 5:
                  this.currentModal = 'FillingFieldModal';
                  break;
              }
              this.modal = true;
              this.modalSize = 'modal-lg';
              this.setTestQuestionProperties(this.question.subjectTopicId, this.question.subjectSectionId, this.question.questionLevel);
            }
          });
    },
  },

  created() {
    this.getQuestions();
    localStorage.removeItem('testContentId');
  }

}
</script>

<style scoped>

</style>
